export const NotePencilIcon = ({ size = 20, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10 12.5H7.5V10L15 2.5L17.5 5L10 12.5Z"
      stroke="#3C3C43"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.125 4.375L15.625 6.875"
      stroke="#3C3C43"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.875 10V12.875C16.875 15.0841 15.0841 16.875 12.875 16.875H7.125C4.91586 16.875 3.125 15.0841 3.125 12.875V7.125C3.125 4.91586 4.91586 3.125 7.125 3.125H10"
      stroke="#3C3C43"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
